import { DARK_MUTED } from '@lyon/utils/theme/colors/darkmuted';
import { ModalOverrides } from 'baseui/modal';

export const MODAL: ModalOverrides = {
  Root: {
    style: {
      backdropFilter: 'blur(5px)',
    },
  },
  Dialog: {
    style: {
      paddingBottom: '24px',
      paddingLeft: '56px',
      paddingRight: '56px',
      backgroundColor: DARK_MUTED.darkmuted700,
    },
  },
  Close: {
    style: {
      display: 'none',
    },
  },
};
